const commonFn = {};

//部门下拉
commonFn.getSysDeptInfoList = function (e) {
    //登录请求
    var that = e;
    //请求地址
    var url = that.globalAPI.plantform + 'sys/dept/getSysDeptInfoList';

    //POST参数
    var postData = {
        data: {},
    };

    postData = that.qs.parse(postData);

    that.axios
        .post(url, postData)
        .then(function (response) {
            if (response.data.code == 1) {
                that.deptInfoList = response.data.data;
            } else {
                that.$message({
                    message: response.data.msg,
                    type: 'warning',
                });
            }
        })
        .catch(function (error) {
            console.log(error);
        });
};

//导出excel
commonFn.exportExcel = function (e, url, title, data) {
    //登录请求
    var that = e;
    const loading = that.$loading({
        lock: true,
        text: '正在导出',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });

    //请求地址
    var url = url;

    //POST参数
    var postData = {
        data
    };

    postData = that.qs.parse(postData);

    that.axios
        .post(url, postData, {
            responseType: 'blob'
        })
        .then(function (response) {
            console.log('开始导出');
            const link = document.createElement('a')
            let blob = new Blob([response.data], {
                type: 'application/vnd.ms-excel'
            });
            link.href = URL.createObjectURL(blob);
            link.download = title;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            loading.close();
        })
        .catch(function (error) {
            console.log(error);
            loading.close();
        });
};

module.exports = commonFn;



// WEBPACK FOOTER //
// ./src/plugin/commonFn.js